// BlueprintLotteryDisplay.js - 图纸/抽奖菜单渲染

import UIStyleHelper from '../UIStyleHelper.js';
import BlueprintSystem from '../BlueprintSystem.js';

const FONT = UIStyleHelper.PIXEL_FONT;
const MENU_LINE = 38;
const LIST_LINE = 34;

export default class BlueprintLotteryDisplay {
    constructor(scene, ui) {
        this.scene = scene;
        this.ui = ui;
    }

    _listTextStyle(selected, color, extra = {}) {
        return {
            fontSize: '14px',
            fill: selected ? UIStyleHelper.getMenuItemFill(true) : color,
            fontFamily: FONT,
            fontStyle: selected ? 'bold' : 'normal',
            align: 'center',
            wordWrap: { width: this.ui.leftPanelWidth || 220 },
            ...extra
        };
    }

    _addListItem(label, y, selected, color, index, onInteract, fontSize = '14px') {
        const text = this.scene.add.text(0, y, label, this._listTextStyle(selected, color, { fontSize }))
            .setOrigin(0.5, 0);
        this._bindItem(text, index, onInteract);
        this.ui.itemList.add(text);
        return text;
    }

    showMenu(menuOptions, selectedIndex, ticketCount, onInteract) {
        this.ui.clearLists();

        menuOptions.forEach((option, index) => {
            let label = option;
            if (option === '抽奖') {
                label = `抽奖\n[券 x${ticketCount}]`;
            }
            this._addListItem(
                label,
                index * MENU_LINE,
                index === selectedIndex,
                '#ffffff',
                index,
                onInteract,
                '16px'
            );
        });

        this.ui.scrollListToIndex(selectedIndex, menuOptions.length, MENU_LINE);
        this._showMenuDetail(menuOptions[selectedIndex], ticketCount);
    }

    showBlueprintList(blueprints, selectedIndex, playerData, onInteract) {
        this.ui.clearLists();
        const items = [...blueprints, { name: '返回', isReturn: true }];
        const rows = [];
        let y = 0;

        items.forEach((item, index) => {
            const selected = index === selectedIndex;
            let label;
            let color = '#ffffff';

            if (item.isReturn) {
                label = '← 返回';
                color = UIStyleHelper.getMenuItemFill(selected, { isInactive: !selected });
            } else {
                const owned = BlueprintSystem.hasBlueprint(playerData, item.equipmentId);
                const status = owned ? '\n[已拥有]' : '';
                label = `${item.name}\n${item.price} G${status}`;
                color = selected
                    ? UIStyleHelper.MENU_COLORS.SELECTED
                    : (owned ? '#666688' : UIStyleHelper.MENU_COLORS.NORMAL);
            }

            const text = this._addListItem(label, y, selected, color, index, onInteract);
            rows.push({ top: y, height: text.height });
            y += text.height + 10;
        });

        const current = rows[selectedIndex] || { top: 0, height: LIST_LINE };
        this.ui.scrollListByItem(current.top, current.height, y);

        if (items[selectedIndex]?.isReturn) {
            this._showReturnDetail();
        } else {
            this._showBlueprintDetail(items[selectedIndex], playerData);
        }
    }

    _showMenuDetail(option, ticketCount) {
        this.ui.itemDetails.removeAll(true);
        const lines = [];

        if (option === '购买图纸') {
            lines.push('【战车装备图纸】', '', '购买后可于战车中心', '合成对应装备。', '', '已拥有的图纸会标注', '[已拥有]。');
        } else if (option === '抽奖') {
            lines.push('【幸运抽奖】', '', `当前抽奖券: ${ticketCount} 张`, '', '完成副本可获得抽奖券。', '奖品含弹药、材料、', '装备碎片乃至史诗装备！', '', ticketCount > 0 ? '按空格开始抽奖。' : '暂无抽奖券。');
        } else {
            lines.push('【离开】', '', '返回世界地图。');
        }

        this._renderDetail(lines, option === '抽奖' && ticketCount > 0 ? '#4cc9f0' : '#cccccc');
    }

    _showBlueprintDetail(blueprint, playerData) {
        if (!blueprint) return;
        const owned = BlueprintSystem.hasBlueprint(playerData, blueprint.equipmentId);
        const lines = [
            blueprint.name,
            '',
            `装备: ${blueprint.equipmentName}`,
            `价格: ${blueprint.price} G`,
            `你的金钱: ${playerData.money} G`,
            '',
            owned ? '状态: 已拥有' : (playerData.money >= blueprint.price ? '状态: 可购买' : '状态: 金钱不足')
        ];
        this._renderDetail(lines, owned ? '#888888' : '#ffcc00');
    }

    _showReturnDetail() {
        this._renderDetail(['返回主菜单', '', '按空格确认。'], '#888888');
    }

    _renderDetail(lines, titleColor = '#ffcc00') {
        lines.forEach((line, i) => {
            const text = this.scene.add.text(0, i * 26 - 80, line, {
                fontSize: i === 0 ? '18px' : '14px',
                fill: i === 0 ? titleColor : '#cccccc',
                fontFamily: FONT,
                fontStyle: i === 0 ? 'bold' : 'normal',
                align: 'center',
                wordWrap: { width: 360 }
            });
            text.setOrigin(0.5, 0);
            this.ui.itemDetails.add(text);
        });
    }

    _bindItem(text, index, onInteract) {
        text.setInteractive({ useHandCursor: true });
        text.on('pointerover', () => onInteract(index, 'hover'));
        text.on('pointerdown', () => onInteract(index, 'click'));
    }
}
